import { render, staticRenderFns } from "./NavListItem.vue?vue&type=template&id=72af9a54&"
import script from "./NavListItem.vue?vue&type=script&lang=js&"
export * from "./NavListItem.vue?vue&type=script&lang=js&"
import style0 from "./NavListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports